/**
 * Worksheet Service
 * Handles all worksheet-related API calls
 */
import api from './api';

const worksheetService = {
  /**
   * Generate a new worksheet
   * @param {Object} worksheetData - Worksheet generation parameters
   * @returns {Promise} API response with worksheet data
   */
  generate: async (worksheetData) => {
    return api.post('/worksheets/generate', worksheetData);
  },

  /**
   * Get templates/presets
   * @returns {Promise} API response with template configurations
   */
  getTemplates: async () => {
    return api.get('/templates');
  },

  /**
   * Upload reference file for worksheet generation
   * @param {FormData} formData - Form data with file
   * @returns {Promise} API response
   */
  uploadReference: async (formData) => {
    return api.post('/worksheets/upload-reference', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  /**
   * Get worksheet by ID
   * @param {string} worksheetId - Worksheet ID
   * @returns {Promise} API response with worksheet data
   */
  getById: async (worksheetId) => {
    return api.get(`/worksheets/${worksheetId}`);
  },

  /**
   * Get worksheet data for a task
   * @param {string} taskId - Task ID
   * @returns {Promise} API response with worksheet data
   */
  getTaskWorksheet: async (taskId) => {
    return api.get(`/tasks/${taskId}/worksheet`);
  },

  /**
   * Get worksheets created by the current user
   * @returns {Promise} API response with worksheets list
   */
  getWorksheets: async (params = {}) => {
    return api.get('/worksheets', { params });
  },

  /**
   * Get reference files uploaded by the current user
   * @param {Object} params - Optional filters: subject, grade
   */
  getReferenceFiles: async (params = {}) => {
    return api.get('/reference-files', { params });
  },

  /**
   * Delete worksheet
   * @param {string} worksheetId - Worksheet ID
   * @returns {Promise} API response
   */
  delete: async (worksheetId) => {
    return api.delete(`/worksheets/${worksheetId}`);
  },
};

export default worksheetService;
